module.exports = __webpack_public_path__ + "static/img/title_01.4370f0d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/active/snail/yayaLand/question/title_01.png
// module id = j0RW
// module chunks = 1